import { createStore } from 'redux';
import { counterReducer } from './reducers/wishlistReducer';

export default createStore(counterReducer);
